/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Home_TitleInputs */

const en_gc_home_title = /** @type {(inputs: Gc_Home_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft.`)
};

const zh_gc_home_title = /** @type {(inputs: Gc_Home_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft。`)
};

/**
* | output |
* | --- |
* | "GridCraft." |
*
* @param {Gc_Home_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_home_title = /** @type {((inputs?: Gc_Home_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Home_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_home_title(inputs)
	return zh_gc_home_title(inputs)
});
export { gc_home_title as "gc.home.title" }